<h2>Enter code</h2>
<p>
  We sent a code to your mobile number <span [style.white-space]="'nowrap'">{{otpService.selectedRecipient.mobilePhone}}.</span>
  Please enter your code to verify your identity. Your code will expire in 5 minutes.
</p>
<h3>Code</h3>
<form [formGroup]="otpVerifyForm" fxLayout="column" (input)="clearFormError()">
  <div fxLayout="row" fxLayoutGap.xs="0" fxLayoutGap.gt-xs="5px">
    <ng-container *ngFor="let formControlName of formControlNames">
      <mat-form-field appearance="outline" class="otp-input">
        <input otpSplitInput matInput formControlName="{{formControlName}}" id="{{formControlName}}" name="{{formControlName}}" />
      </mat-form-field>
    </ng-container>
  </div>
  <mat-error *ngIf="!(otpService.passed) && otpService.error && (otpService.error.errorMessages.length > 0)">
    <span *ngFor="let errorMessage of otpService.error.errorMessages">
      <mat-icon fontSet="iinet-icons" inline="true" fontIcon="iii-cross"></mat-icon>
      {{errorMessage | parseOtpErrorMessage}}
    </span>
  </mat-error>
  <div fxLayout="row wrap" class="form-row-container" fxLayoutGap.xs="0" fxLayoutGap.gt-xs="20px">
    <button *ngIf="otpService.verifying" mat-button [disabled]="true" fxFlex.xs="100" fxFlexOrder.xs="0" fxFlexOrder.gt-xs="2">
      <span class="loading-icon-bubbles">Sending...</span>
    </button>
    <button *ngIf="!otpService.verifying && otpService.error?.errorCode != 'EXPIRED'" id="verify-button" class="btn-chevron" mat-raised-button color="action" (click)="verifyOtp()" [disabled]="!otpService.otpCode" fxFlex.xs="100" fxFlexOrder.xs="0" fxFlexOrder.gt-xs="2">
      <span>Verify</span>
      <mat-icon fontSet="iinet-icons" fontIcon="iii-point-thin"></mat-icon>
    </button>
    <button *ngIf="otpService.error?.errorCode == 'EXPIRED'" id="resend-button" class="btn-chevron" mat-raised-button color="action" (click)="resend()" fxFlex.xs="100" fxFlexOrder.xs="0" fxFlexOrder.gt-xs="2">
      <span>Resend code</span>
      <mat-icon fontSet="iinet-icons" fontIcon="iii-point-thin"></mat-icon>
    </button>
    <button id="cancel-button" mat-raised-button color="secondary" (click)="back()" fxFlex.xs="100" fxFlexOrder.xs="2" fxFlexOrder.gt-xs="0">
      Back
    </button>
  </div>
</form>
<p *ngIf="otpService.error?.errorCode != 'EXPIRED'" class="resend-paragraph">Didn't receive a code? <a id="resend-link" (click)="resend()">Resend code</a></p>
